import { scrollToHandler } from 'Assets/js/lib/smoothscroll'
;(function () {
  const components = {
    textOnlyFilters: SAXX.Init.Component((node) => {
      document
        .querySelector(':root')
        .style.setProperty(
          '--additional-scroll-to-offset',
          `${node.clientHeight}`,
        )

      node.querySelectorAll('.filerable-link').forEach((link) => {
        link.addEventListener('click', function (event) {
          event.preventDefault()
          const targetId = this.getAttribute('data-href')
          const targetElement = document.querySelector(targetId)
          if (targetElement) {
            scrollToHandler(targetId)
          }
        })
      })
    }),
  }
  Object.assign(SAXX.Init.Components, components)
})()
